import { VALIDATOR_TYPES, getValidator } from "Validation/validator";

// These limits are what our DB currently allows for these columns
const TEMPLATE_NAME_MAX_LENGTH = 256;
const TEMPLATE_DESCRIPTION_MAX_LENGTH = 2048;

/* Mirror of DocumentType in DocumentTypeConstant.cs */
export const DOCUMENT_TYPE = {
    Docx: 0,
    Ics: 1,
    Pdf: 2,
    Xlsx: 3,
    Merge: 4
};

export const FILE_EXT = {
    Docx: "docx",
    Ics: "ics",
    Pdf: "pdf",
    Xlsx: "xlsx"
};
export function getDocumentTypeName(documentType) {
    switch (documentType) {
        case DOCUMENT_TYPE.Docx:
            return "Docx";
        case DOCUMENT_TYPE.Ics:
            return "Ics";
        case DOCUMENT_TYPE.Pdf:
            return "Pdf";
        case DOCUMENT_TYPE.Xlsx:
            return "Xlsx";
        default:
            return "";
    }
}

const normalizeName = function (name) {
    if (!name) {
        return name;
    }
    return name.trim().toLowerCase();
};

export function getTemplateNameValidator($app, initialName, inUseNames, errorMsg) {
    const normalizedName = inUseNames.map((name) => normalizeName(name));
    const normalizedInitialName = normalizeName(initialName);

    const _isNameAvailable = function (name) {
        if (!name) {
            return true;
        }

        const valNormalized = normalizeName(name);
        // If we're keeping same name while editing template, that's fine
        if (valNormalized === normalizedInitialName) {
            return true;
        }

        return !normalizedName.includes(valNormalized);
    };

    return getValidator($app, [
        VALIDATOR_TYPES.required,
        {
            type: VALIDATOR_TYPES.custom,
            validate: _isNameAvailable,
            errorMsg: errorMsg
        },
        {
            type: VALIDATOR_TYPES.maxLength,
            maxLength: TEMPLATE_NAME_MAX_LENGTH
        }
    ]);
}

export function getTemplateDescriptionValidator($app) {
    return getValidator($app, {
        type: VALIDATOR_TYPES.maxLength,
        maxLength: TEMPLATE_DESCRIPTION_MAX_LENGTH
    });
}
